export default function findLabelByKey(key, object) {
  const result = object.find((property) => property.key === key)
  return result && result.label ? result.label : null
}